import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './modules/login/components/login/login.component';
import { AuthguardGuard } from './core/guards/authguard.guard';
import { NotFoundComponent } from './modules/not-found/not-found.component';
// import { SelectDbComponent } from './select-db/select-db.component';
import { HaRegisterComponent } from './modules/HospitalPanel/components/ha-register/ha-register/ha-register.component';
import { ForgotPasswordComponent } from './modules/login/components/forgot-password/forgot-password.component';
import { ForgotChangePasswordComponent } from './modules/login/components/forgot-change-password/forgot-change-password.component';
import { PaRegistrationComponent } from './modules/PatientPanel/components/Pa-register/pa-registration/pa-registration.component';
import { InvoiceDetailsComponent } from './modules/invoice-details/invoice-details.component';
import { PaypalManagementComponent } from './modules/Paypal/components/paypal-management/paypal-management.component';
import { PaypalManagementProductComponent } from './modules/Paypal/components/paypal-management-product/paypal-management-product.component';
import { PaypalManagementCustomerInfoComponent } from './modules/Paypal/components/paypal-management-customer-info/paypal-management-customer-info.component';
import { PaypalPaymentViaLinkComponent } from './modules/Paypal/components/paypal-payment-via-link/paypal-payment-via-link.component';
import { ForgotUsernameComponent } from './modules/login/components/forgot-username/forgot-username.component';
import { NgModule } from '@angular/core';
import { SurveyViaLinkComponent } from './modules/survey-via-link/survey-via-link.component';


export const AppRoutes: Routes = [
 
  {
    path: 'SA',
    canActivate: [AuthguardGuard],
    data: { roles: ['SA'] },
    loadChildren: () => import('./modules/SuperAdmin/SuperAdmin.module').then(m => m.SaModuleModule)
  },
  {
    path: 'Hospital',
    canActivate: [AuthguardGuard],
    data: { roles: ['HA', 'UHA'] },
    loadChildren: () => import('./modules/HospitalPanel/HospitalPanel.module').then(m => m.HaModuleModule)
  },
  {
    path: 'Patient',

    canActivate: [AuthguardGuard],
    data: { roles: ['PA'] },
    loadChildren: () => import('./modules/PatientPanel/PatientPanel.module').then(m => m.PaModuleModule)
  },
  {
    path: 'Register',
    component: HaRegisterComponent,
    canActivate: [AuthguardGuard],
    data: { roles: ['REG'] },
  },
  {
    path: 'InvoiceDetails',
    component: InvoiceDetailsComponent,
  },
  {
    path: 'BuyIPSProduct',
    component: PaypalManagementComponent,
  },
  {
    path: 'IPSPayment',
    component: PaypalPaymentViaLinkComponent,
  },
  {
    path: 'BuyIPSProductPromo',
    component: PaypalManagementProductComponent,
  },
  {
    path: 'PaypalManagementCustomerInfo',
    component: PaypalManagementCustomerInfoComponent,
  },
  {
    path: 'PARegister',
    canActivate: [AuthguardGuard],
    data: { roles: ['PAREG'] },
    component: PaRegistrationComponent,
  },
  {
    path: 'Forgot',
    component: ForgotPasswordComponent
  },
  {
    path: 'ForgotUsername',
    component: ForgotUsernameComponent
  },
  {
    path: 'NewPass',
    component: ForgotChangePasswordComponent
  },
  {
    path: 'SurveyViaLink',
    component: SurveyViaLinkComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },

  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'notFound',
    component: NotFoundComponent
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];
@NgModule({
  imports: [RouterModule.forRoot(AppRoutes)],
  exports: [RouterModule]
})

export class appRoutingModule { };
